import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (!email || !password) { setError('Remplissez tous les champs'); return; }
    setLoading(true);
    setError('');
    try {
      const user = await login(email, password);
      if (user.role === 'admin') navigate('/admin');
      else if (user.role === 'organisateur') navigate('/dashboard');
      else navigate('/territoire');
    } catch (err) {
      setError(err.message || 'Email ou mot de passe incorrect');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      paddingTop: 'var(--nav-h, 64px)', minHeight: '100vh',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#F5F0E8'
    }}>
      <div style={{
        background: '#fff', border: '1px solid rgba(140,122,106,0.2)',
        borderRadius: 4, padding: 48, maxWidth: 400, width: '100%', margin: '0 20px'
      }}>
        <div style={{ width: 48, height: 48, background: 'var(--radar-deep)', borderRadius: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Space Mono, monospace', fontWeight: 700, color: '#fff', fontSize: 18, marginBottom: 28 }}>R</div>
        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 6 }}>Connexion</h1>
        <p style={{ color: '#8C7A6A', fontSize: 14, marginBottom: 28 }}>Espace organisateur & administrateur RADAR</p>

        <div style={{ marginBottom: 18 }}>
          <label style={{ display: 'block', fontFamily: 'Space Mono, monospace', fontSize: 10, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#8C7A6A', marginBottom: 6 }}>Email</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleSubmit()}
            placeholder="vous@exemple.fr"
            style={{ width: '100%', padding: '12px 16px', border: `1px solid ${error ? 'var(--radar-orange)' : 'rgba(140,122,106,0.3)'}`, borderRadius: 2, fontFamily: 'Familjen Grotesk, sans-serif', fontSize: 15, outline: 'none' }} />
        </div>
        <div style={{ marginBottom: 24 }}>
          <label style={{ display: 'block', fontFamily: 'Space Mono, monospace', fontSize: 10, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#8C7A6A', marginBottom: 6 }}>Mot de passe</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleSubmit()}
            placeholder="••••••••"
            style={{ width: '100%', padding: '12px 16px', border: `1px solid ${error ? 'var(--radar-orange)' : 'rgba(140,122,106,0.3)'}`, borderRadius: 2, fontFamily: 'Familjen Grotesk, sans-serif', fontSize: 15, outline: 'none' }} />
        </div>

        {error && <p style={{ color: 'var(--radar-orange)', fontSize: 13, marginBottom: 16 }}>{error}</p>}

        <button onClick={handleSubmit} disabled={loading} style={{
          width: '100%', padding: '13px', background: 'var(--radar-deep)', color: '#fff', border: 'none',
          borderRadius: 2, fontFamily: 'Space Mono, monospace', fontSize: 13, letterSpacing: '0.06em',
          textTransform: 'uppercase', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1,
          marginBottom: 20
        }}>
          {loading ? 'Connexion...' : 'Se connecter →'}
        </button>

        {/* ADDED: Forgot Password Link */}
        <div style={{ textAlign: 'center' }}>
          <Link to="/forgot-password" style={{ 
            color: '#8C7A6A', fontSize: 13, textDecoration: 'none', fontFamily: 'Familjen Grotesk, sans-serif' 
          }}>
            Mot de passe oublié ?
          </Link>
        </div>
      </div>
    </div>
  );
}